import { AxiosProgressEvent } from 'axios'
import { useEffect, useState } from 'react'

export type UploadProgressStatus = 'ERROR' | 'STOPED' | 'UPLOADING' | 'FINISH'

export default function useUploadProgress() {
  const [uploadStatus, setUploadStatus] = useState<UploadProgressStatus>('STOPED')
  const [isLoadingAPI, setIsLoadingAPI] = useState(false)
  const [uploadProgress, setUploadProgress] = useState(0)

  const onUploadProgress = (event: AxiosProgressEvent) => {
    if (!event.total) return 0
    const progress = Math.round((event.loaded * 100) / event.total)
    setUploadProgress(progress)
  }

  useEffect(() => {
    if (uploadProgress === 100) setIsLoadingAPI(true)
  }, [uploadProgress])

  useEffect(() => {
    if (uploadStatus === 'FINISH') setIsLoadingAPI(false)
  }, [uploadStatus])

  return { isLoadingAPI, uploadStatus, setUploadStatus, uploadProgress, setUploadProgress, onUploadProgress }
}
